export const API_URL = "https://adminapi.meitechx.com/";

export const END_POINTS = {
  // on-boarding
  login: "onboarding/admin/login",
  get_user: "onboarding/admin",
  logout: "onboarding/admin/logout",
  forgotPassword: "onboarding/admin/sendOtp",
  resetPassword: "/onboarding/admin/verifyOtp",
  updateProfile: "onboarding/admin/updateProfile",
  changePassword: "onboarding/admin/changePassword",

  // users
  getUsers: "/customers/admin",
  getDocuments: "/customers/admin/documents",
  verifyDocuments: "/customers/admin/verify-documents",
  getUserById: "customers/admin",
  addUser: "customers/admin/add",
  updateUsers: "customers/admin/update",
  deleteUser: "customers/admin",
  exportUsers: "customers/admin/exportCsv",

  // upload
  upload: "media/admin",

  // category
  addCategory: "category/admin/add",
  getCategory: "category/admin",
  getCategoryById: "category/admin",
  updateCategory: "category/admin/update",
  deleteCategory: "category/admin/delete",
  getCategoryDropDownList: "category/admin/dropdownList",

  // boost plans
  addBoostPlans: "boostplans/admin/add",
  getBoostPlans: "boostplans/admin",
  getBoostPlansDropDownList: "boostplans/admin",
  getBoostPlansById: "boostplans/admin",
  updateBoostPlans: "boostplans/admin/update",
  deleteBoostPlans: "boostplans/admin",

  // product listing
  getProduct: "product/admin",
  getProductById: "product/admin",
  updateProduct: "product/admin/update",
  deleteProduct: "product/admin",
  exportProduct: "product/admin/exportCsv",

  // access-role
  addsubAdminRole: "accessroles/admin/add",
  getSubAdminRole: "accessroles/admin",
  getSubAdminByIdRole: "accessroles/admin",
  deleteSubAdminRole: "accessroles/admin",
  updateSubAdminRole: "accessroles/admin/update",
  getRoleDropDownList: "accessroles/admin/getDropdownList",

  // sub admin
  getSubAdmin: "subadmins/admin/",
  getSubAdminById: "subadmins/admin",
  addsubAdmin: "subadmins/admin/add",
  updateSubAdmin: "subadmins/admin/update",
  deleteSubAdmin: "subadmins/admin",

  // faq
  getFAQ: "faq/admin/",
  getFAQById: "faq/admin",
  addFAQ: "faq/admin/add",
  updateFAQ: "faq/admin/update",
  deleteFAQ: "faq/admin",

  // cms
  getCMS: "/cms/admin",
  updateCMS: "/cms/admin/update",

  // transactions
  getTransactions: "transactions/admin/",

  // followers
  getUserFollowers: "follow/admin/getUserFollowers",

  // revenueAnalytics
  getRevenueAnalytics: "revenueAnalytics/admin/",
  usersGraph: "revenueAnalytics/admin/usersGraph",
  productsGraph: "revenueAnalytics/admin/productsGraph",
  revenueGraph: "revenueAnalytics/admin/revenueGraph",
  productReportsGraph: "revenueAnalytics/admin/productReportsGraph",
  productViewsGraph: "revenueAnalytics/admin/productViewsGraph",

  //notifications
  notificationsAdd: "notifications/admin/add",
  notificationsGet: "notifications/admin",
  notificationsDelete: "notifications/admin/delete",
  notificationsMyNotifications: "notifications/admin/myNotifications",

  //manage reviews
  getManageReviews: "product/admin/getReviews",
  getReviewbyId: "product/admin/review",
  deleteReview: "product/admin/review",
  updateReview: "product/admin/review",
};
